export const coupons = {
  list_title: "Cupones",
  list_cta: "Crear cupón",
  list_empty_title: "Aún no tienes cupones",
  list_empty_description:
    "Crea tu primer cupón para atraer más clientes con descuentos canjeables.",
  search_placeholder: "Buscar cupón",
  reload: "Recargar",
  filters: {
    actives: "Activos",
    inactive: "Inactivos",
    finished: "Finalizados",
  },
  status: {
    active: "Activo",
    inactive: "Inactivo",
    finished: "Finalizado",
  },
  card: {
    all_store: "Toda la tienda",
    products: "{{count}} productos",
    code: "Código {{code}}",
    usages: "{{current}} / {{max}} usos",
    usages_unlimited: "{{current}} usos",
    always_available: "Sin fecha de vencimiento",
    valid_from: "Desde {{date}}",
    valid_until: "Hasta {{date}}",
    valid_range: "{{start}} - {{end}}",
  },
  delete_modal: {
    title: "Eliminar cupón",
    description:
      "¿Estás seguro de que deseas eliminar este cupón? Esta acción no se puede deshacer.",
    cancel: "Cancelar",
    delete: "Eliminar",
  },
  wizard: {
    title_create: "Crear cupón",
    title_edit: "Editar cupón",
    back: "Atrás",
    save: "Guardar cupón",
    create: "Crear cupón",
    locked_hint:
      "Algunos campos no se pueden editar porque el cupón ya fue compartido.",
  },
  form: {
    name: "Nombre del cupón",
    name_placeholder: "Ej: Descuento verano",
    code_preview: "Código generado",
    discount_type: "Tipo de descuento",
    type_percentage: "Porcentaje",
    type_value: "Monto fijo",
    discount_value: "Valor del descuento",
    scope: "Alcance",
    scope_store: "Toda la tienda",
    scope_products: "Productos específicos",
    schedule_dates: "Programar vigencia",
    start_date: "Fecha de inicio",
    end_date: "Fecha de fin",
    usage_limit: "Limitar cantidad de usos",
    max_usages: "Máximo de usos",
    purchase_condition: "Condición de compra",
    purchase_none: "Sin condición",
    purchase_first_order: "Solo primera compra",
    purchase_min: "Compra mínima",
    min_purchase_value: "Monto mínimo",
  },
  selector: {
    search_products: "Buscar producto",
    no_products: "No tienes productos disponibles",
    max_products: "Puedes seleccionar hasta {{count}} productos",
    selected_count: "{{count}} seleccionados",
  },
  detail: {
    title: "Detalle del cupón",
    edit: "Editar",
    code: "Código",
    discount: "Descuento",
    dates: "Vigencia",
    no_dates: "Sin fechas programadas",
    usages: "Usos",
    scope: "Alcance",
    purchase_condition: "Condición",
    redemptions: "Redenciones",
    no_redemptions: "Aún no hay redenciones",
    customer: "Cliente",
    phone: "Teléfono",
    date: "Fecha",
    copy_code: "Copiar código",
    copy_link: "Copiar link de tienda",
    copied: "Copiado",
  },
  messages: {
    created: "Cupón creado correctamente",
    updated: "Cupón actualizado correctamente",
    deleted: "Cupón eliminado",
    error_save: "No se pudo guardar el cupón",
    error_delete: "No se pudo eliminar el cupón",
    error_load: "No se pudieron cargar los cupones",
    validation_generic: "Revisa los campos del formulario",
    validation_name: "El nombre es obligatorio",
    validation_discount: "Ingresa un descuento válido",
    validation_scope: "Selecciona hasta 5 productos o toda la tienda",
  },
};
